export default "__VITE_ASSET__3a9ef210__"